import FormValidation from '../modules/FormValidation';
import Modal from '../modules/Modal';
export default class CustomerPage {
    constructor() {
        this.formResponseElement = null;
        this.formValidation = null;
        this.init();
    }
    init() {
        console.log('CustomerProfile initialized');
        // init forms and validation
        this.initRegistrationForm();
        this.initLoginForm();
        this.initUpdateProfileForm();
        this.initForgotPasswordForm();
        this.initPasswordRecoveryForm();
        // init delete profile confirmation modal if present
        const deleteProfileModalEl = document.querySelector('[data-modal="confirm-delete-profile"]');
        if (deleteProfileModalEl) {
            new Modal('confirm-delete-profile');
        }
    }
    initRegistrationForm() {
        const registrationForm = document.querySelector('form#customer-register');
        if (!registrationForm)
            return;
        this.formValidation = new FormValidation(registrationForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#form-error-message'
        });
        // Handle form submission
        registrationForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }
    initLoginForm() {
        const loginForm = document.querySelector('form#customer-login');
        if (!loginForm)
            return;
        this.formValidation = new FormValidation(loginForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#form-error-message'
        });
        // Handle form submission
        loginForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }
    initUpdateProfileForm() {
        const updateProfileForm = document.querySelector('form#customer-update-profile');
        if (!updateProfileForm)
            return;
        this.formValidation = new FormValidation(updateProfileForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            // Match existing markup id in template
            generalErrorSelector: '#form-error-message'
        });
        // Prevent browser autofill on password fields
        this.preventPasswordAutofill(updateProfileForm);
        // Handle form submission
        updateProfileForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }
    initForgotPasswordForm() {
        const forgotPasswordForm = document.querySelector('form#customer-forgot-password');
        if (!forgotPasswordForm)
            return;
        this.formValidation = new FormValidation(forgotPasswordForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#form-error-message'
        });
        // Handle form submission
        forgotPasswordForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }
    initPasswordRecoveryForm() {
        const passwordRecoveryForm = document.querySelector('form#customer-password-recovery');
        if (!passwordRecoveryForm)
            return;
        this.formValidation = new FormValidation(passwordRecoveryForm, {
            showErrorsOnSubmit: true,
            clearErrorsOnFocus: true,
            generalErrorSelector: '#form-error-message'
        });
        // Handle form submission
        passwordRecoveryForm.addEventListener('submit', this.handleFormSubmission.bind(this));
    }
    handleFormSubmission(event) {
        event.preventDefault();
        const form = event.target;
        this.formResponseElement = form.querySelector('[data-form-response]') || document.querySelector('[data-form-response]');
        if (!this.formValidation) {
            this.formValidation = new FormValidation(form, {
                showErrorsOnSubmit: true,
                clearErrorsOnFocus: true,
                generalErrorSelector: '#form-error-message'
            });
        }
        // Clear previous errors
        this.formValidation.clearAllErrors();
        // Determine which submit button triggered the submission (supports multiple buttons with name="action")
        const submitEvent = event;
        let submitter = null;
        if (typeof submitEvent.submitter !== 'undefined') {
            submitter = submitEvent.submitter;
        }
        if (!submitter) {
            const activeElement = document.activeElement;
            if (activeElement && activeElement instanceof HTMLButtonElement && form.contains(activeElement)) {
                submitter = activeElement;
            }
        }
        this.submitForm(form, submitter);
    }
    submitForm(form, submitter) {
        const submitButton = submitter || form.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true;
        }
        const data = new FormData(form);
        // If multiple submit buttons exist, ensure the clicked one contributes its name/value (FormData(form) omits submit buttons by spec)
        if (submitter && submitter.name) {
            // Remove any existing value for the same name to avoid duplicates
            if (data.has(submitter.name)) {
                data.delete(submitter.name);
            }
            data.append(submitter.name, submitter.value);
        }
        const options = {
            method: 'POST',
            body: data
        };
        fetch(window.localize_script.admin_ajax, options)
            .then(response => response.json())
            .then(response => {
            var _a;
            if (response.success) {
                // Handle success response from wp_send_json_success
                if (this.formResponseElement) {
                    this.formResponseElement.classList.remove('hidden');
                    this.formResponseElement.classList.add('form-success');
                    this.formResponseElement.innerHTML = response.data.message || '';
                }
                this.redirect_after_success(response.data.redirect_to);
            }
            else {
                // Handle error response from wp_send_json_error
                if (this.formValidation && response.data) {
                    this.formValidation.showErrors(response);
                }
                else {
                    console.error('Failed:', ((_a = response.data) === null || _a === void 0 ? void 0 : _a.message) || 'Unknown error');
                }
            }
        })
            .catch(error => {
            console.error('Error submitting form:', error);
            if (this.formValidation) {
                this.formValidation.showGeneralError('An error occurred. Please try again later.');
            }
        })
            .finally(() => {
            if (submitButton) {
                submitButton.disabled = false;
            }
        });
    }
    redirect_after_success(redirect_to) {
        if (redirect_to) {
            window.location.href = redirect_to;
        }
    }
    preventPasswordAutofill(form) {
        const passwordFields = form.querySelectorAll('input[type="password"]');
        // Clear password fields on page load
        passwordFields.forEach(field => {
            field.value = '';
            // Add readonly attribute initially and remove it on focus
            field.setAttribute('readonly', 'true');
            field.addEventListener('focus', () => {
                field.removeAttribute('readonly');
            });
            // Re-add readonly on blur if field is empty
            field.addEventListener('blur', () => {
                if (!field.value) {
                    field.setAttribute('readonly', 'true');
                }
            });
        });
        // Additional protection: clear fields after a short delay
        setTimeout(() => {
            passwordFields.forEach(field => {
                field.value = '';
            });
        }, 100);
        // Clear fields when form becomes visible (for dynamic content)
        const observer = new MutationObserver(() => {
            if (form.offsetParent !== null) {
                passwordFields.forEach(field => {
                    field.value = '';
                });
            }
        });
        observer.observe(form, { attributes: true, attributeFilter: ['style', 'class'] });
    }
}
